import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import userImg from '../../../../assets/img/user.png';
import { styled } from '@mui/material/styles';
import { useAuth } from '../../../auth';
import { useTheme } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SwitchAccountOutlinedIcon from '@mui/icons-material/SwitchAccountOutlined';
// Styled component for Avatar with hover effect
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  '&:hover': {
    border: `2px solid ${theme.palette.primary.light}`, // Change the color as per your theme
    cursor: 'pointer',
  },
  width: '36px',
  height: '36px',
}));

const Profile = () => {
  const theme = useTheme();
  const { currentUser, logout } = useAuth();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('episodeData');
    logout();
  };
  return (
    <>
      <StyledAvatar alt={currentUser?.first_name} src={userImg} onClick={handleClick} />
      <Menu
        sx={{
          '& .MuiPaper-root': {
            marginTop: '5px',
            minWidth: '235px',
            maxWidth: '235px',
          },
          '& .MuiList-root': {
            padding: '5px',
          },
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          sx={{
            '&:hover': {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.primary.light,
            },
            height: '50px',
            borderRadius: '4px',
          }}
          onClick={handleClose}
        >
          <div className=' flex gap-3 items-center justify-center cursor-pointer'>
            <AccountCircleOutlinedIcon color='primary' className=' w-[24px]' />
            <span>Profile</span>
          </div>
        </MenuItem>
        <MenuItem
          sx={{
            '&:hover': {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.primary.light,
            },
            height: '50px',
            borderRadius: '4px',
          }}
          onClick={handleLogout}
        >
          <div className=' flex gap-3 items-center justify-center cursor-pointer'>
            <SwitchAccountOutlinedIcon color='primary' className=' w-[24px]' />
            <span>Switch Account</span>
          </div>
        </MenuItem>
        <MenuItem
          sx={{
            '&:hover': {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.primary.light,
            },
            height: '50px',
            borderRadius: '4px',
          }}
          onClick={handleLogout}
        >
          <div className=' flex gap-3 items-center justify-center cursor-pointer'>
            <LogoutOutlinedIcon color='primary' className=' w-[24px]' />
            <span>Logout</span>
          </div>
        </MenuItem>
      </Menu>
    </>
  );
};

export default Profile;
